import { httpEnrollmentClient } from '../common/httpClient';
import API_CONST from '@/constants/ApiConst';
import {
  CatalogSessionFilters,
  CatalogSessionList,
  CatalogSessionListRequest,
} from '@/Model/sessions/catalogTypes';

export function retrieveCatalogSessionList(
  catalogSessionRequest: CatalogSessionListRequest
) {
  return httpEnrollmentClient({ interceptor: false }).post<CatalogSessionList>(
    `${API_CONST.SESSION_CATALOG}`,
    catalogSessionRequest
  );
}

export function retrieveCatalogSessionFilters(accountId: number) {
  return httpEnrollmentClient({ interceptor: false }).get<
    CatalogSessionFilters
  >(`${API_CONST.SESSION_CATALOG_FILTERS}?accountId=${accountId}`);
}
